import { render, staticRenderFns } from "./DialogFlag.vue?vue&type=template&id=400dfaef&"
import script from "./DialogFlag.vue?vue&type=script&lang=js&"
export * from "./DialogFlag.vue?vue&type=script&lang=js&"
import style0 from "./DialogFlag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports